import React from 'react';
import { SectionReveal } from '../SectionReveal';
import { PriceBlock } from '../PriceBlock';
import { VALUE_ROWS, VALUE_TOTAL, PRICE_TODAY } from '../../data/content';
export function ValueTable() {
  return <section className="w-full bg-carbon" aria-labelledby="value-heading" data-id="element-202">
      <SectionReveal className="mx-auto w-full max-w-2xl px-5 py-16 sm:py-20" data-id="element-203">
        <h2 id="value-heading" className="mb-8 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-204">
          📦 Tu Megapack completo
        </h2>

        <div className="overflow-hidden rounded-lg border border-gold-tenue" data-id="element-205">
          {/* Header row */}
          <div className="flex items-center justify-between gap-3 bg-orange px-5 py-3 text-white" data-id="element-206">
            <span className="font-heading text-sm font-bold uppercase" data-id="element-207">
              Lo que recibís
            </span>
            <span className="font-heading text-sm font-bold uppercase" data-id="element-208">
              Valor
            </span>
          </div>

          {/* Item rows */}
          <ul data-id="element-209">
            {VALUE_ROWS.map((row, i) => <li key={row.label} className={`flex items-center justify-between gap-4 px-5 py-3.5 ${i % 2 === 0 ? 'bg-carbon-2' : 'bg-carbon-3'}`} data-id="element-210">
                <span className="min-w-0 break-words text-sm text-soft" data-id="element-211">
                  {row.label}
                </span>
                <span className="flex-none text-sm text-muted" data-id="element-212">
                  {row.value}
                </span>
              </li>)}
          </ul>

          {/* Total */}
          <div className="flex items-center justify-between gap-4 border-t border-gold bg-carbon-3 px-5 py-4" data-id="element-213">
            <span className="font-heading text-sm font-extrabold uppercase text-gold" data-id="element-214">
              Valor total
            </span>
            <span className="font-display text-xl font-extrabold text-gold" data-id="element-215">
              {VALUE_TOTAL}
            </span>
          </div>

          {/* Hoy */}
          <div className="flex items-center justify-between gap-4 border-t border-gold-tenue bg-carbon px-5 py-4" data-id="element-216">
            <span className="font-heading text-sm font-extrabold uppercase text-orange" data-id="element-217">
              Hoy
            </span>
            <span className="font-display text-2xl font-extrabold text-soft" data-id="element-218">
              {PRICE_TODAY}
            </span>
          </div>
        </div>

        <div className="mt-12" data-id="element-219">
          <PriceBlock data-id="element-220" />
        </div>
      </SectionReveal>
    </section>;
}